const dialogInjectionKey = Symbol("dialogInjectionKey");

export { dialogInjectionKey };
//# sourceMappingURL=dialog.mjs.map
